var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card my-3 px-3 py-3",staticStyle:{"width":"46%"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',{staticStyle:{"color":"#000","text-align":"center"}},[_c('i',{staticClass:"fas fa-phone-slash"}),_vm._v(" Ligações Abandonadas\n  ")])
}]

export { render, staticRenderFns }